import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { DATA_METRIC_MODE } from "../consts";
import { logger } from "../logger";
import { fireEvents } from "../utils/fireEvents";
import { getMetricAttrs } from "../utils/getMetricAttrs";
var MetricEventListener = /*#__PURE__*/_createClass(function MetricEventListener(helpers) {
  var _this = this;
  _classCallCheck(this, MetricEventListener);
  _defineProperty(this, "helpers", void 0);
  _defineProperty(this, "_globalClickMetricHandler", function (event) {
    var _event$target;
    var element =
    // @ts-expect-error getAttribute
    ((_event$target = event.target) === null || _event$target === void 0 ? void 0 : _event$target.getAttribute(DATA_METRIC_MODE)) === 'click' && event.target ||
    // @ts-expect-error closest
    event.target.closest("[".concat(DATA_METRIC_MODE, "='click']"));
    if (element) {
      var _getMetricAttrs = getMetricAttrs(element),
        name = _getMetricAttrs.name,
        data = _getMetricAttrs.data;
      fireEvents(name, _this.helpers, data);
      logger.debug("Trigger: click, name: ".concat(name), ['Element:', element], ['Config', getMetricAttrs(element)]);
    }
  });
  _defineProperty(this, "disconnect", function () {
    if (typeof window !== 'undefined' && typeof document !== 'undefined') {
      document.removeEventListener('click', _this._globalClickMetricHandler);
    }
  });
  this.helpers = helpers;
  if (typeof window !== 'undefined' && typeof document !== 'undefined') {
    document.addEventListener('click', this._globalClickMetricHandler);
    logger.debug('Global click listener started');
  }
});
export default MetricEventListener;